'use strict';

exports.__esModule = true;
exports['default'] = componentWillReceiveProps;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function componentWillReceiveProps(value) {
  return (0, _property2['default'])('componentWillReceiveProps', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/componentWillReceiveProps.js
// module id = 581
// module chunks = 1